import React from "react";
import { Html } from "@react-three/drei";
import { styles } from "./styles";

interface PersonUIProps {
  showText: boolean;
  dialogIsOpen: boolean;
  isUnlocked: boolean;
  isCompleted: boolean;
  isLookingAtPlayer: boolean;
  name?: string;
  onInteract: () => void;
}

export const PersonUI: React.FC<PersonUIProps> = ({
  showText,
  dialogIsOpen,
  isUnlocked,
  isCompleted,
  isLookingAtPlayer,
  name,
  onInteract
}) => {
  if (!showText || dialogIsOpen) return null;

  return (
    <Html position={[0, 2, 0]} center>
      <div style={styles.personBtnCont}>
        {isUnlocked ? (
          <button
            onClick={onInteract}
            style={styles.personButton}
          >
            <span style={styles.personButtonShine} />
            Hi, I'm {name}...
          </button>
        ) : (
          <button style={{ ...styles.personButton, ...styles.personButtonLocked }}>
            <span style={styles.lockedIcon}>🔒</span>
            Locked
          </button>
        )}
        {/* Completed indicator (always visible if completed) */}
        {isCompleted && isLookingAtPlayer && (
          <div style={styles.compleatedContainer}>
            <span style={styles.completedIcon}>✓</span>
            Completed
          </div>
        )}
      </div>

      <style>{`
        @keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
        @keyframes shine { 0% { left: -100%; } 60% { left: 100%; } 100% { left: 100%; } }
      `}</style>
    </Html>
  );
};

